import { useState } from "react"
import classes from "../../stats/Statistics.module.css"
import { Interval } from "../../navigation/tabs/Tabs";
import {subDays} from "date-fns"
import { Area } from "../../navigation/tree/Area";
import { Layout, Layouts, Responsive, WidthProvider } from "react-grid-layout";
import WithTreeTab from "../WithTreeTab";
import { Graph, GraphType } from "../../graph/Graph";
import { getRangeEndDate, getRangeStartDate } from "../../helpers/Storage";

const WifiNetwork = () => {

    const endDate = getRangeEndDate() === null ? Date.now() : getRangeEndDate() as number
    const startDate = getRangeStartDate() === null ? subDays(endDate, 1) : new Date(getRangeStartDate() as number)
    startDate.setHours(0,0,0,0);

    const ResponsiveReactGridLayout = WidthProvider(Responsive);
    const [layouts, setLayouts] = useState<Layouts>({})

    // const [selectedTab, setSelectedTab] = useState<TabItem>(items[0])
    const [startPeriodTimestamp, setStartPeriodTimestamp] = useState<number>(startDate.getTime())
    const [endPeriodTimestamp, setEndPeriodTimestamp] = useState<number>(endDate)

    const [_, setSelectedNodeId] = useState<string|undefined>(undefined)
    const [selectedNodePath, setSelectedNodePath] = useState<string|undefined>(undefined)
    const [selectedArea, setSelectedArea] = useState<Area|undefined>(undefined)

    const [interval, setInterval] = useState<Interval>(Interval.DAY)

    const onSelectArea = (area: Area, nodeId: string, nodePath: string) => {
        console.log("select area", area)
        setSelectedNodeId(nodeId)
        setSelectedArea(area)
        setSelectedNodePath(nodePath)
    }

    return (
        <WithTreeTab
            items={[]}
            onPeriodChanged={(startDateTimestamp, endDateTimestamp) => {
                setStartPeriodTimestamp(new Date(startDateTimestamp).getTime())
                setEndPeriodTimestamp(new Date(endDateTimestamp).getTime())}}
            onIntervalChanged={(newInterval) => setInterval(newInterval)}
            onSelectArea={onSelectArea}>


                {selectedNodePath !== undefined && selectedArea !== undefined ? (
                    <ResponsiveReactGridLayout
                        rowHeight={100}
                        cols={{ lg: 12, md: 12, sm: 6, xs: 4, xxs: 2 }}
                        layouts={layouts}
                        onLayoutChange={(_currentLayout: Layout[], allLayouts: Layouts) => {
                            // Check to prevent infinite refresh
                            if(JSON.stringify(allLayouts) !== JSON.stringify(layouts)){
                                setLayouts(allLayouts)
                            }
                        }}>

                            <div className={classes.ChartContainer} key={"sessions_count_evolution"} data-grid={{ w: 6, h: 3, x: 0, y: 0, static: true }}>
                                    <label>Évolution du nombre de sessions</label>
                                    <div className={classes.ChartTitleSeparator}/>
                                    <div className={classes.ChartGraphContainer}>            
                                        <Graph
                                            preventUpdateAnimations={false}
                                            graphType={GraphType.SESSIONS_COUNT_EVOLUTION}
                                            startDatePeriodTimestamp={startPeriodTimestamp}
                                            interval={interval}
                                            nodePath={selectedNodePath}
                                            mediaspotSerial={selectedArea.mediaspot?.serial}
                                            endDatePeriodTimestamp={endPeriodTimestamp}/>
                                    </div>
                            </div>

                      
                    </ResponsiveReactGridLayout>)
                : <div key="empty_0"/> }
        </WithTreeTab>    
    )
}

export default WifiNetwork